import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'

interface Props {
  slpRate: number | null
}

/**
 * The model's score for this document, or "Not run".
 *
 * Deliberately NOT bucketed into "Looks good" / "Needs a closer look". No threshold for that
 * split exists in the backend — `slpRate` is documented only as "score returned by the model" —
 * so bucketing would put a judgement the backend never made in front of a reviewer deciding how
 * closely to read a document. The AI review's real `decision` field is shown on the review
 * screen, where it is actually available. See the design's §5.3 and follow-up §9.5.
 */
const AiScoreCellComponent = ({ slpRate }: Props) => {
  if (slpRate === null || slpRate === undefined) {
    return (
      <Typography variant="body2" css={tw`text-shades-400`}>
        Not run
      </Typography>
    )
  }

  return <Typography variant="body2">{slpRate.toFixed(2)}</Typography>
}

export const AiScoreCell = memo(AiScoreCellComponent)
